module.exports = __webpack_public_path__ + "img/jetpack.48c8a307.svg";